import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import {
  REPAIR_REPORT_INSPECTION_RESULT_OPTIONS,
} from '#/modules/crmMgmt/aftersales/repairReport/helper/repairReportStatus';

function displayDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function formatResultLabel(result) {
  const found = REPAIR_REPORT_INSPECTION_RESULT_OPTIONS.find(
    (option) => option.value === result,
  );
  return found?.label ?? displayDash(result);
}

function buildInspectionColumns() {
  return [
    {
      id: 'description',
      header: '項目說明',
      accessorFn: (row) => displayDash(row.description),
      size: 240,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'result',
      header: '結果',
      accessorFn: (row) => formatResultLabel(row.result),
      size: 120,
    },
  ];
}

const RepairReportInspectionItemsTable = ({ items = [] }) => {
  const columns = useMemo(() => buildInspectionColumns(), []);
  const rows = useMemo(
    () => (items ?? []).map((item, index) => ({
      ...item,
      id: item?.id ? String(item.id) : `item-${index}`,
    })),
    [items],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

RepairReportInspectionItemsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default RepairReportInspectionItemsTable;
